import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Subject } from 'rxjs';
import { FeedbackPopupComponent } from '../feedback-popup/feedback-popup.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-feedback-button',
  templateUrl: './feedback-button.component.html',
  styleUrl: './feedback-button.component.scss',
  standalone: true,
  imports: [
    MatIcon,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackButtonComponent implements OnDestroy {
  private readonly componentDestroyed = new Subject<void>();

  constructor(private dialog: MatDialog) {
  }

  /**
   * Compute right offset since the element is rotated by -90deg
   * @param buttonHeight
   * @param buttonWidth
   */
  getPositionRight(buttonWidth: number, buttonHeight: number) {
    return -((buttonWidth / 2) - (buttonHeight / 2));
  }

  /**
   * Opens a popup for a feedback survey.
   */
  openFeedbackDialog() {
    this.dialog
        .open(FeedbackPopupComponent, {
          width: '400px',
          autoFocus: false,
        });
  }

  ngOnDestroy() {
    this.componentDestroyed.next();
  }
}
